/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "2.8.0",
  "gitBuildTime": "2025-11-25T13:53:07.925Z",
  "gitBuildVersion": "2.8.0",
  "gitCommitId": "fa0f97d",
  "gitCommitIdFull": "fa0f97d078104d5d5761deea5e5bddf59e2df34b",
  "gitCommitTime": "2025-11-25T13:51:43.000Z",
  "version": "2.8.0-2025-11-25T13:51:43.000Z-(fa0f97d)"
};
